import * as React from "react"
import * as styles from "./styles.module.scss"

const SidebarItem = () => {
  return (
    <div className={styles.item}>
      <div className={styles.content}>
        <div className={styles.diskWrap}>
          <i className={styles.disk}></i>
        </div>
        <div className={styles.blocks}>
          <i className={styles.heading}></i>
          <i className={styles.text}></i>
          <i className={styles.text}></i>
        </div>
        <div className={styles.videoWrap}>
          <div className={styles.video}></div>
        </div>
      </div>
    </div>
  )
}

export default SidebarItem
